import React from 'react';

const DocumentNoneIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      style={{
        height: props.height ? `${props.height}px` : '',
        width: props.height ? `${props.height * 0.75}px` : ''
      }}
      viewBox="0 0 18 24"
    >
      <path fill="#5080B0" d="M1 0v23h16.5V7l-7-7H1Z"/>
      <path fill="#0A3250" fillRule="evenodd" d="M17.498 7.073 10.988.5a1.802 1.802 0 0 0-.446-.323c-.016-.01-.034-.017-.05-.024l-.015-.007A1.677 1.677 0 0 0 9.797 0H1.71C.778 0 0 .755 0 1.688v20.625C0 23.244.778 24 1.71 24h14.602c.933 0 1.665-.755 1.665-1.688V8.262c0-.446-.165-.872-.479-1.189ZM10 1l7 7h-6a1 1 0 0 1-1-1V1Zm6 22a1 1 0 0 0 1-1V8.8h-6.138C9.84 8.8 8.987 7.995 8.987 7V1H2a1 1 0 0 0-1 1v20a1 1 0 0 0 1 1h14Z" clipRule="evenodd"/>
      <path fill="#0A3250" fillRule="evenodd" d="M8.998 10.5c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5Zm-3.93 5.014c0-2.157 1.784-3.905 3.987-3.905.922 0 1.77.308 2.442.825L5.91 17.906a3.807 3.807 0 0 1-.843-2.392Zm1.43 3.051a3.99 3.99 0 0 0 2.442.825c2.203 0 3.987-1.747 3.987-3.905 0-.903-.314-1.732-.843-2.391l-5.586 5.471Z" clipRule="evenodd"/>
    </svg>
  );
};

DocumentNoneIcon.props = { height: 24 };
export default DocumentNoneIcon;
